import { Component, EventEmitter, Input, OnInit, Output, Self, Optional } from '@angular/core';
import { ControlValueAccessor, NgControl, NgModel, Validators } from '@angular/forms';
import { RfrSelectOptions } from './types';

@Component({
  selector: 'rfr-select',
  templateUrl: './rfr-select.component.html',
  styleUrls: ['./rfr-select.component.scss'],
})
export class RfrSelectComponent implements ControlValueAccessor, OnInit {
  @Input() options!: RfrSelectOptions[];
  @Input() readonly: boolean = false;
  @Input() labelText: string = '';
  @Input() placeholder: string = '';
  @Input() required: boolean = false;
  @Input() error: boolean = false;
  @Input() optionValue: 'full' | 'valueOnly' = 'valueOnly';
  @Input() fill: 'outline' | 'solid' | undefined = undefined;
  @Output() blur: EventEmitter<void> = new EventEmitter<void>();
  disabled: boolean = false;
  defaultValue: any;
  @Output() selectedChange = new EventEmitter<string>();
  constructor(
    @Self() @Optional() public controlDir: NgControl,
    @Self() @Optional() public ngModel: NgModel
  ) {
    if (this.controlDir) {
      this.controlDir.valueAccessor = this;
    } else if (this.ngModel) {
      this.ngModel.valueAccessor = this;
    }
  }

  ngOnInit(): void {
    // const control = this.controlDir?.control ?? this.ngModel?.control;
    // if (control) {
    //   if (this.required) {
    //     control.setValidators(Validators.required);
    //   } else {
    //     control.clearValidators();
    //   }
    //   control.updateValueAndValidity();
    // }
  }

  writeValue(value: any): void {
    // Set the value if it's not already set
    if (value !== undefined && this.getDefaultValue() !== value) {
      this.setDefaultAndNotify(value);
    }
  }

  registerOnChange(onChange: (value: any) => void): void {
    this.onChange = onChange;
  }

  registerOnTouched(onTouched: () => void): void {
    this.onTouched = onTouched;
  }

  setDisabledState(disabled: boolean): void {
    this.disabled = disabled;
  }

  onBlur(): void {
    // this.onTouched(); // Manually trigger the onTouched method
    this.blur.emit(); // Emit the blur event
  }

  onChangeInput(event: any): void {
    const value = event.detail.value;
    this.onChange(value);
    this.setDefaultAndNotify(value);
    this.selectedChange.emit(value);
  }

  validate(): boolean | null | undefined {
    return this.required && this.error; // (this.error || (this.controlDir?.errors && this.controlDir?.control?.touched));
  }

  private onChange: any = () => { };
  private onTouched: any = () => { };

  private setDefaultAndNotify(value: any): void {
    this.defaultValue = value;
    this.onChange(value);
  }

  private getDefaultValue(): any {
    return this.defaultValue;
  }
}
